export * from './nextup.component';

